// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__p3wlW"};